import PropTypes from 'prop-types'
import React from 'react'
import Link, { TARGET_BLANK } from 'components/Link'
import {
  URL_ROKU_APP_STORE,
  URL_ANDROID_APP_STORE,
  URL_APPLE_APP_STORE,
  URL_AMAZON_APP_STORE_FIRE_TV,
} from 'services/url/constants'

function AppLinks (props) {
  const { label } = props
  return (
    <div className="app-links">
      <p className="app-links__label">{label}</p>
      <ul className="app-links__list">
        <li className="app-links__list-item">
          <Link
            target={TARGET_BLANK}
            to={URL_ROKU_APP_STORE}
            className="app-links__link--roku"
          />
        </li>
        <li className="app-links__list-item">
          <Link
            target={TARGET_BLANK}
            to={URL_ANDROID_APP_STORE}
            className="app-links__link--android"
          />
        </li>
        <li className="app-links__list-item">
          <Link
            target={TARGET_BLANK}
            to={URL_APPLE_APP_STORE}
            className="app-links__link--iphone"
          />
        </li>
        <li className="app-links__list-item">
          <Link
            target={TARGET_BLANK}
            to={URL_APPLE_APP_STORE}
            className="app-links__link--ipad"
          />
        </li>
        <li className="app-links__list-item">
          <Link
            target={TARGET_BLANK}
            to={URL_APPLE_APP_STORE}
            className="app-links__link--tvos"
          />
        </li>
        <li className="app-links__list-item">
          <Link
            target={TARGET_BLANK}
            to={URL_AMAZON_APP_STORE_FIRE_TV}
            className="app-links__link--firetv"
          />
        </li>
      </ul>
    </div>
  )
}

AppLinks.propTypes = {
  label: PropTypes.string,
}

export default React.memo(AppLinks)
